import { render, staticRenderFns } from "./GutenbergBook.vue?vue&type=template&id=934bdbea&scoped=true"
import script from "./GutenbergBook.vue?vue&type=script&lang=js"
export * from "./GutenbergBook.vue?vue&type=script&lang=js"
import style0 from "./GutenbergBook.vue?vue&type=style&index=0&id=934bdbea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934bdbea",
  null
  
)

export default component.exports